import { ListingCardMarkerOverlay } from './ListingCardMarkerOverlay';

export class ListingRentEstimatorCardMarkerOverlay extends ListingCardMarkerOverlay {}
